let baseHref = null;
let currentToken = 0;

const badgeState = {
    message: false,
    call: false,
};

const getFaviconLink = () => {
    let link = document.querySelector('link[rel~="icon"]');
    if (link) return link;

    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
    return link;
};

const ensureBaseHref = (link) => {
    if (!baseHref) {
        baseHref = link.getAttribute('href') || `${window.location.origin}/kwik_favicon.png`;
    }
};

const drawBadge = (href, token) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = href;

    img.onload = () => {
        if (token !== currentToken) return;
        const link = getFaviconLink();
        if (!link) return;

        const size = img.naturalWidth || 32;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        ctx.clearRect(0, 0, size, size);
        ctx.drawImage(img, 0, 0, size, size);

        const radius = Math.ceil(size * 0.2);
        const centerX = size - radius;
        const centerY = radius;

        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
        ctx.fillStyle = '#e53935';
        ctx.fill();

        ctx.lineWidth = Math.max(1, Math.ceil(size * 0.06));
        ctx.strokeStyle = '#ffffff';
        ctx.stroke();

        link.href = canvas.toDataURL('image/png');
    };

    img.onerror = () => {
        if (token !== currentToken) return;
        const link = getFaviconLink();
        if (!link) return;
        link.href = href;
    };
};

const applyBadge = () => {
    const link = getFaviconLink();
    if (!link) return;

    ensureBaseHref(link);

    const shouldShow = Object.values(badgeState).some(Boolean);
    currentToken += 1;

    if (!shouldShow) {
        link.href = baseHref;
        return;
    }

    drawBadge(baseHref, currentToken);
};

export const setFaviconBadge = (key, active) => {
    if (!(key in badgeState)) return;
    if (badgeState[key] === Boolean(active)) return;

    badgeState[key] = Boolean(active);
    applyBadge();
};

export const clearFaviconBadge = (key) => {
    setFaviconBadge(key, false);
};

export const resetFaviconBadge = () => {
    Object.keys(badgeState).forEach((key) => {
        badgeState[key] = false;
    });
    applyBadge();
};
